const club1Menu = [
  {
    "label": "manager",
    "key": "manager",
    "role": "manager",
    "icon": "pi pi-briefcase",
    "items":
      [
        {"label": "agreement", "url": "/manager/agreements", "icon": "pi pi-file-edit"},
        {"label": "club_info", "url": "/manager/company/info", "icon": "pi pi-globe"},
        {"label": "club_members", "url": "/manager/member/list", "icon": "pi pi-users"},
        {"label": "teams", "url": "/manager/team/list", "icon": "pi pi-prime"},
        {"label": "trainings", "url": "/manager/trainings/list", "icon": "pi pi-stopwatch"},
        {"label": "attendance", "url": "/manager/trainings/attendance", "icon": "pi pi-chart-line"},
        {"label": "billing", "url": "/manager/billing/info", "icon": "pi pi-dollar"},
        {"label": "tournaments", "url": "/manager/tournaments/list", "icon": "pi pi-star-fill"},
        {"label": "games", "url": "/manager/games/list", "icon": "pi pi-sitemap"},
        {"label": "game_teams", "url": "/manager/game_teams/list", "icon": "pi pi-th-large"}
      ]
  },
  {
    "label": "trainer",
    "key": "trainer",
    "role": "trainer",
    "icon": "pi pi-flag-fill",
    "items": [
      {"label": "teams","url": "/trainer/team/list","icon": "pi pi-prime"},
      {"label": "attendance","url": "/trainer/trainings", "icon": "pi pi-chart-line"},
      {"label": "team_members","url": "/trainer/members", "icon": "pi pi-users"},
      {"label": "games","url": "/trainer/games/list","icon": "pi pi-sitemap"},
      {"label": "game_teams", "url": "/trainer/game_teams/list", "icon": "pi pi-th-large"}
    ]
  },
  {
    "label": "parent",
    "key": "parent",
    "role": "parent",
    "icon": "pi pi-heart-fill",
    "items":
      [
        {"label": "my_children", "url": "/parent/children/list", "icon": "pi pi-users"},
        {"label": "attendance", "url": "/parent/children/attendance", "icon": "pi pi-chart-line"},
        {"label": "billing", "url": "/parent/children/billing", "icon": "pi pi-dollar"},
        {"label": "tournaments", "url": "/parent/children/games", "icon": "pi pi-star-fill"}
      ]
  },
  {
    "label": "member",
    "key": "member",
    "role": "member",
    "icon": "pi pi-user",
    "items":
      [
        {"label": "about_me", "url": "/member/about", "icon": "pi pi-briefcase"},
        {"label": "attendance", "url": "/member/attendance", "icon": "pi pi-chart-line"},
        {"label": "billing", "url": "/member/billing", "icon": "pi pi-dollar"},
        {"label": "tournaments", "url": "/member/games", "icon": "pi pi-star-fill"}
      ]
  },
  {
    "label": "Club #1",
    "key": "anonymous",
    "role": "anonymous",
    "icon": "pi pi-star-fill",
    "items": [
      {"label": "clubs", "url": "/", "icon":  "pi pi-search"},
      {"label": "for_club_owners", "url": "/demo", "icon":  "pi pi-briefcase"},
      {"label": "contacts", "url": "/contacts", "icon":  "pi pi-telegram"},
      {"label": "login", "url": "/login", "icon":  "pi pi-lock-open"}
    ]
  }
]
export default club1Menu